export default "__VITE_ASSET__DIoMrjz1__"